import NotificationSystemsController from './notificationSystemsController';
import notificationSystemsTemplate from './notificationSystems.html';

import notifiersTemplate from "./notifiers/notifiers.html";
import NotifiersController from "./notifiers/notifiers.controller";

import endpointsTemplate from "./endpoints/endpoints.html";
import EndpointsController from "./endpoints/endpoints.controller";

export default function notificationSystemsRouter($stateProvider) {
  $stateProvider
    .state('app.notification-systems', {
      url: '/notification-systems',
      templateUrl: notificationSystemsTemplate,
      controller: NotificationSystemsController,
      controllerAs: 'vm',
      data: {
        authorizedRoles: ['SUPER_ADMIN'],
      },
    })
    .state('app.notification-systems.notifiers', {
      url: '/:notificationSystemId/notifiers',
      templateUrl: notifiersTemplate,
      controller: NotifiersController,
      controllerAs: 'vm',
      params: {
        notificationSystemId: null,
      },
      data: {
        authorizedRoles: ['SUPER_ADMIN'],
      },
    })
    .state('app.notification-systems.endpoints', {
      url: '/:notificationSystemId/endpoints',
      templateUrl: endpointsTemplate,
      controller: EndpointsController,
      controllerAs: 'vm',
      params: {
        notificationSystemId: null,
      },
      data: {
        authorizedRoles: ['SUPER_ADMIN'],
      },
    })
}



// WEBPACK FOOTER //
// ./src/app/webhooks/notificationSystemsRouter.js